import React from "react";
import { FormBuilder } from "components/FormBuilder/FormBuilder";
import ProcessorTable from "./ProcessorTable";
// import NoticeBox from "components/NoticeBox/NoticeBox";
// // import { Typography } from "@mui/material";
// import { useTranslation } from "react-i18next";

// const LOCALE_KEY = "page.merchants.addMerchant.";

const ProcessorSection = ({ formProps, isLoading, mccDropdownOptions }) => {
  // const { t } = useTranslation();

  // const handleExclusiveGatewayOnCheck = (cardType, enabledProcessor, processors) => {
  //   const { setValue } = formProps;
  //   setValue(`processors.${cardType}.inUse`, "NONE"); // Logically will always end up as NONE, since options are mutually exclusive

  //   processors.filter((processor) => processor !== enabledProcessor).forEach((processor) => {
  //     setValue(`processors.${cardType}.gateways.${processor}.enabled`, false)
  //   });
  // }

  return (
    <FormBuilder.Section innerStyle={{ gap: "32px" }}>
      <ProcessorTable
        formProps={formProps}
        config={{
          cardTypeKey: "VISA",
          defaultValues: {
            inUse: "YEDPAY",
          },
          unavailableFields: ["referrerCommission"],
          gateways: [
            // {
            //   gatewayKey: "ALLINPAY",
            //   defaultValues: {
            //     enabled: true,
            //     businessPlan: "sme"
            //   }
            // },
            // {
            //   gatewayKey: "FUBON",
            //   defaultValues: {
            //     enabled: true,
            //     businessPlan: "sme"
            //   }
            // },
            {
              gatewayKey: "YEDPAY",
              defaultValues: {
                enabled: true,
                businessPlan: "sme"
              }
            },
          ]
        }}
        mccOptions={mccDropdownOptions}
        disabled={isLoading}
      />
      <ProcessorTable
        formProps={formProps}
        config={{
          cardTypeKey: "MASTER",
          defaultValues: {
            inUse: "YEDPAY",
          },
          unavailableFields: ["referrerCommission"],
          gateways: [
            // {
            //   gatewayKey: "ALLINPAY",
            //   defaultValues: {
            //     enabled: true,
            //     businessPlan: "sme"
            //   }
            // },
            // {
            //   gatewayKey: "FUBON",
            //   defaultValues: {
            //     enabled: true,
            //     businessPlan: "normal"
            //   }
            // },
            {
              gatewayKey: "YEDPAY",
              defaultValues: {
                enabled: true,
                businessPlan: "sme"
              }
            },
          ]
        }}
        mccOptions={mccDropdownOptions}
        disabled={isLoading}
      />
      {/* <ProcessorTable
        formProps={formProps}
        config={{
          cardTypeKey: "UNIONPAY",
          defaultValues: {
            inUse: "FUBON",
          },
          gateways: [
            {
              gatewayKey: "ALLINPAY",
              defaultValues: {
                enabled: true,
                businessPlan: "normal"
              }
            },
            {
              gatewayKey: "FUBON",
              defaultValues: {
                enabled: true,
                businessPlan: "sme"
              }
            },
          ]
        }}
        mccOptions={mccDropdownOptions}
        disabled={isLoading}
      />
      <ProcessorTable
        formProps={formProps}
        config={{
          cardTypeKey: "JCB",
          defaultValues: {
            inUse: "ALLINPAY",
          },
          gateways: [
            {
              gatewayKey: "ALLINPAY",
              defaultValues: {
                enabled: true,
                businessPlan: "sme"
              }
            },
          ]
        }}
        mccOptions={mccDropdownOptions}
        disabled={isLoading}
      />
      <FormBuilder.Section innerStyle={{ gap: "8px" }}>
        <NoticeBox><Typography variant="content">{t(LOCALE_KEY + "notice.amexBbmslOnboard")}</Typography></NoticeBox>
        <ProcessorTable
          formProps={formProps}
          config={{
            cardTypeKey: "AMEX",
            gateways: [
              {
                gatewayKey: "AMEX_BBMSL",
                defaultValues: {
                  businessPlan: "sme"
                },
                // These two processors are mutually exclusive
                specialHandling: {
                  enabledOnCheckFn: () => handleExclusiveGatewayOnCheck("AMEX", "AMEX_BBMSL", ["AMEX_BBMSL", "AMEX"])
                }
              },
              {
                gatewayKey: "AMEX",
                unavailableFields: ["businessPlan", "mcc"],
                specialHandling: {
                  enabledOnCheckFn: () => handleExclusiveGatewayOnCheck("AMEX", "AMEX", ["AMEX_BBMSL", "AMEX"])
                }
              },
            ]
          }}
          mccOptions={mccDropdownOptions}
          disabled={isLoading}
        />
      </FormBuilder.Section>
      <ProcessorTable
        formProps={formProps}
        config={{
          cardTypeKey: "OCTOPUS",
          unavailableFields: ["foreignMdr"],
          gateways: [
            {
              gatewayKey: "OCTOPUS",
              unavailableFields: ["businessPlan", "mcc"],
              // These three processors are mutually exclusive
              specialHandling: {
                enabledOnCheckFn: () => handleExclusiveGatewayOnCheck("OCTOPUS", "OCTOPUS", ["OCTOPUS", "OCTOPUS_BBMSL", "OCTOPUS_HKBN"])
              }
            },
            {
              gatewayKey: "OCTOPUS_BBMSL",
              unavailableFields: ["businessPlan", "mcc"],
              specialHandling: {
                enabledOnCheckFn: () => handleExclusiveGatewayOnCheck("OCTOPUS", "OCTOPUS_BBMSL", ["OCTOPUS", "OCTOPUS_BBMSL", "OCTOPUS_HKBN"])
              }
            },
            {
              gatewayKey: "OCTOPUS_HKBN",
              unavailableFields: ["businessPlan", "mcc"],
              specialHandling: {
                enabledOnCheckFn: () => handleExclusiveGatewayOnCheck("OCTOPUS", "OCTOPUS_HKBN", ["OCTOPUS", "OCTOPUS_BBMSL", "OCTOPUS_HKBN"])
              }
            },
          ]
        }}
        mccOptions={mccDropdownOptions}
        disabled={isLoading}
      /> */}
      <ProcessorTable
        formProps={formProps}
        config={{
          cardTypeKey: "WECHAT",
          defaultValues: {
            inUse: "WECHAT_PAY",
          },
          unavailableFields: ["foreignMdr"],
          gateways: [
            {
              gatewayKey: "WECHAT_PAY",
              unavailableFields: ["businessPlan"],
              defaultValues: {
                enabled: true,
              }
            },
          ]
        }}
        mccOptions={mccDropdownOptions}
        disabled={isLoading}
      />
      <ProcessorTable
        formProps={formProps}
        config={{
          cardTypeKey: "ALIPAY",
          defaultValues: {
            inUse: "ALIPAY",
          },
          unavailableFields: ["foreignMdr"],
          gateways: [
            {
              gatewayKey: "ALIPAY",
              unavailableFields: ["businessPlan"],
              defaultValues: {
                enabled: true,
              }
            },
          ]
        }}
        mccOptions={mccDropdownOptions}
        disabled={isLoading}
      />
      {/* <ProcessorTable
        formProps={formProps}
        config={{
          cardTypeKey: "PAYME",
          unavailableFields: ["foreignMdr"],
          gateways: [
            {
              gatewayKey: "HSBC",
              unavailableFields: ["businessPlan"]
            },
          ]
        }}
        mccOptions={mccDropdownOptions}
        disabled={isLoading}
      /> */}
    </FormBuilder.Section>
  );
};

export default React.memo(ProcessorSection);


